<eup-error-page
	statusCode="404"
	errorHeader="{{'Errors.Error_404_Title' | translate}}">
</eup-error-page>